var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 404,
    viewBox: "0 0 404 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H403.2V403.2H0V0Z",
    fill: "#41558D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9770_27121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 317.197C262.518 317.197 313.2 266.516 313.2 203.997C313.2 141.478 262.518 90.7969 200 90.7969C137.481 90.7969 86.7998 141.478 86.7998 203.997C86.7998 266.516 137.481 317.197 200 317.197Z",
    fill: "#7A97CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 90.7969C215.011 90.7969 229.408 96.7601 240.022 107.375C250.637 117.989 256.6 132.386 256.6 147.397C256.6 162.408 250.637 176.805 240.022 187.419C229.408 198.034 215.011 203.997 200 203.997C184.989 203.997 170.592 209.96 159.978 220.575C149.363 231.189 143.4 245.586 143.4 260.597C143.4 275.608 149.363 290.005 159.978 300.619C170.592 311.234 184.989 317.197 200 317.197C230.022 317.197 258.815 305.27 280.044 284.041C301.274 262.812 313.2 234.019 313.2 203.997C313.2 173.974 301.274 145.182 280.044 123.952C258.815 102.723 230.022 90.7969 200 90.7969Z",
    fill: "#D4ECA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 164.997C209.72 164.997 217.6 157.117 217.6 147.397C217.6 137.677 209.72 129.797 200 129.797C190.28 129.797 182.4 137.677 182.4 147.397C182.4 157.117 190.28 164.997 200 164.997Z",
    fill: "#D4ECA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 278.2C209.72 278.2 217.6 270.32 217.6 260.6C217.6 250.88 209.72 243 200 243C190.28 243 182.4 250.88 182.4 260.6C182.4 270.32 190.28 278.2 200 278.2Z",
    fill: "#7A97CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9770_27121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 253,
    height: 253,
    fill: "white",
    transform: "translate(75.1997 75.7031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.af77c7a3e9a3b6ea80d7e84eb188e567.svg";
export { ForwardRef as ReactComponent };